import React, { useEffect, useRef } from 'react';

const Stopwatch = ({ isRunning, time }) => {
  const tickerRef = useRef(null);
  const fullRotationDuration = 6; // Full rotation duration in seconds
  const degreesPerSecond = 360 / fullRotationDuration;

  useEffect(() => {
    if (tickerRef.current) {
      const newRotation = (time * degreesPerSecond) % 360;
      tickerRef.current?.setAttribute(
        'transform',
        `rotate(${newRotation} 16 21.4286)`,
      );
    }
  }, [time]);

  useEffect(() => {
    let animationFrameId;
    const startTime = Date.now() - time * 1000;

    const animate = () => {
      const elapsedTime = (Date.now() - startTime) / 1000;
      const newRotation = (elapsedTime * degreesPerSecond) % 360;
      tickerRef.current?.setAttribute(
        'transform',
        `rotate(${newRotation} 16 21.4286)`,
      );
      animationFrameId = requestAnimationFrame(animate);
    };

    if (isRunning) {
      animationFrameId = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(animationFrameId);
    } else if (tickerRef.current) {
      const newRotation = (time * degreesPerSecond) % 360;
      tickerRef.current?.setAttribute(
        'transform',
        `rotate(${newRotation} 16 21.4286)`,
      );
    }
  }, [isRunning, time]);

  return (
    <svg
      width="34"
      height="38"
      viewBox="0 0 34 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon"
    >
      <rect
        x="12.878"
        width="6.77791"
        height="3.39286"
        rx="1.69643"
        fill="#121314"
      />
      <rect
        width="6.78181"
        height="3.39091"
        rx="1.69545"
        transform="matrix(0.7067 0.707514 -0.7067 0.707514 29.2073 3.96088)"
        fill="#121314"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 37.4286C24.8366 37.4286 32 30.2651 32 21.4286C32 12.592 24.8366 5.42856 16 5.42856C7.16344 5.42856 0 12.592 0 21.4286C0 30.2651 7.16344 37.4286 16 37.4286ZM16 33.4286C22.6274 33.4286 28 28.056 28 21.4286C28 14.8012 22.6274 9.4286 16 9.4286C9.37258 9.4286 4 14.8012 4 21.4286C4 28.056 9.37258 33.4286 16 33.4286Z"
        fill="#121314"
      />
      <rect
        ref={tickerRef}
        x="14.5"
        y="12.93"
        width="3"
        height="10"
        rx="1.5"
        fill="#121314"
      />
    </svg>
  );
};

export default Stopwatch;
